import React, { SVGProps } from 'react';

const EyeOff: React.FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        d="M10 5.833c2.3 0 4.167 1.867 4.167 4.167 0 .542-.109 1.05-.3 1.525l2.433 2.433A9.848 9.848 0 0019.158 10C17.717 6.342 14.167 3.75 10 3.75a9.704 9.704 0 00-3.317.583l1.8 1.8a3.97 3.97 0 011.517-.3zM1.667 3.558l1.9 1.9.383.384A9.837 9.837 0 00.833 10c1.442 3.658 5 6.25 9.167 6.25 1.292 0 2.525-.25 3.65-.7l.35.35 2.442 2.433 1.058-1.058L2.725 2.5 1.667 3.558zm4.608 4.609l1.292 1.291A2.351 2.351 0 007.5 10c0 1.383 1.117 2.5 2.5 2.5.183 0 .367-.025.542-.067l1.291 1.292a4.13 4.13 0 01-1.833.442A4.168 4.168 0 015.833 10c0-.658.167-1.275.442-1.833zm3.592-.65l2.625 2.625.016-.134c0-1.383-1.116-2.5-2.5-2.5l-.141.009z"
        fill="#333"
      />
    </g>
  </svg>
);

export default EyeOff;
